<template>
    <div id="param-modal" v-if="inner_params">
        <modal class="modal" :show="modal_show" body-classes="card-body" modal-classes="modal-dialog-centered modal-lg"
            footer-classes="card-footer" header-classes="card-header" v-on:close="onClose()">

            <template v-slot:header>
                <h2>{{ $t(this.$route.name + '.moduleParamModalTitle', { name: module_id }) }}</h2>
            </template>
            <template v-slot:default>
                <div v-if="inner_params" id="parameters-form">
                    <div v-for="(index, param) in inner_params" :key="index" class="row">
                        <div class="col">
                            <div v-if="getItemByParamName(param) == null">
                                <div class="row">
                                    <div class="col">

                                        <ParamInput :title="$t($route.name + '.module_' + param)"
                                            :type="typeof inner_params[param] === 'boolean' ? 'switch' : 'number'"
                                            :popover="$t($route.name + '.module_' + param + 'InfoPopover')"
                                            v-model="inner_params[param]">
                                        </ParamInput>
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <ParamInputGroup :title="$t($route.name + '.module_' + param)"
                                    :popover="$t($route.name + '.module_' + param + 'InfoPopover')"
                                    v-model="inner_params[param]"></ParamInputGroup>
                            </div>
                        </div>
                    </div>
                </div>
            </template>


            <template v-slot:footer>
                <div class="row">
                    <div class="col">
                        <base-button type="primary" class="btn btn-block btn-default" v-on:click="handleUpdateParams()">
                            {{ $t(this.$route.name + '.updateParams') }}
                        </base-button>
                    </div>
                    <div class="col">
                        <base-button type="primary" class="btn btn-block btn-outline-default"
                            v-on:click="onRestoreButton()">
                            {{ $t(this.$route.name + '.restoreParams') }}
                        </base-button>
                    </div>
                    <div class="col">
                        <base-button type="primary" class="btn btn-block btn-warning" v-on:click="onClose()">
                            {{ $t(this.$route.name + '.cancelButton') }}
                        </base-button>
                    </div>
                </div>
            </template>

        </modal>
    </div>
</template>

<script>
import ModuleService from '@/services/module.service'
import ModuleModel from './module.model'
import ParamInput from '@/components/ParamInput.vue';
import ParamInputGroup from '@/components/ParamInputGroup.vue';

export default {
    name: "param-modal",
    components: {
        ParamInput,
        ParamInputGroup
    },
    props: {
        modal_show: {
            type: Boolean,
            default: false,
        },
        params: null,
        module_id: {
            type: String,
            default: "None"
        },
        module_name: {
            type: String,
            default: "None"
        },
        on_data_submit: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            show: {
                type: Boolean,
                default: false,
            },
            inner_params: null,
            original_params: null,
            request_done: false,
        };
    },
    created() {
        if (this.params) {
            delete this.params.soil_moisture_min_optimal_region_percentage;
            this.inner_params = JSON.parse(JSON.stringify(this.params));
            this.original_params = JSON.parse(JSON.stringify(this.params));
        } else {
            this.inner_params = JSON.parse(JSON.stringify(ModuleModel.module_params_read_model));
            this.original_params = JSON.parse(JSON.stringify(ModuleModel.module_params_read_model));
        }
    },
    methods: {
        onClose: function () {
            this.inner_params = JSON.parse(JSON.stringify(this.original_params));
            this.$emit('update:modal_show', false);
        },

        onRestoreButton: function () {
            this.inner_params = JSON.parse(JSON.stringify(this.original_params));
        },

        getItemByParamName: function (param_name) {
            var item = this.inner_params[param_name];
            if (typeof item === 'object') {
                return item;
            }
        },

        async handleUpdateParams() {
            if (this.request_done) {
                return;
            }
            this.request_done = true;

            this.inner_params.soil_moisture_min_optimal_region_percentage = this.getPmpByCC(this.inner_params.soil_moisture_max_optimal_region_percentage)

            await ModuleService.updateParamsByModuleId(this.module_id, this.inner_params);

            // Reload the page to refresh data
            this.request_done = false;

            this.$router.go();

        },

        getParamValueByParamName: function (param_name, sub_param_name) {
            var item;
            if (sub_param_name != null) {
                item = this.inner_params[param_name];
            } else {
                item = this.inner_params[param_name][sub_param_name];
            }
            return item;
        },

        getPmpByCC(cc){
            return cc * 0.74 - 5;
        }
    }
};
</script>
<style>
.modal {
    overflow: auto !important;
}
</style>
